// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__C1RaY","image-container":"Loader_image-container__XL+8l"};